import PropTypes from 'prop-types'
import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'

import classes from './OverlayImageItem.module.scss'

const OverlayImageItem = forwardRef(({ isDragging, image, ...props }, ref) => {
  const { t } = useTranslation()

  return (
    <div
      className={classes.overlayImageWrapper}
      ref={ref}
      style={{
        cursor: isDragging ? 'grabbing' : 'grab',
        transform: isDragging ? 'scale(1.05)' : 'scale(1)',
      }}
      {...props}
    >
      <img
        className={classes.overlayImageThumbnail}
        src={image.file_url}
        alt={t('proShop.configCustomItem.selectedImageAlt')}
      />
    </div>
  )
})

OverlayImageItem.displayName = 'OverlayImageItem'

OverlayImageItem.propTypes = {
  isDragging: PropTypes.bool,
  image: PropTypes.shape({
    file_url: PropTypes.string,
  }),
}

export default OverlayImageItem
